<div class="container-fluid padding-top margin-bottom">
  <md-card *ngIf="locationData">
    <div class="row">
      <div class="col-md-12">
        <button class="btn btn-primary"
                color="primary"
                [routerLink]="['/clients/'+ key ]">Go Back</button>
        <img src="{{ (client | async)?.logoUrl }}"
             class="logo text-center"
             alt="">
        <h1 class=" text-center">{{ (client | async)?.name}}</h1>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-4 col-sm-offset-2">
        <h5>Select a Location</h5>
        <app-select-location-dropdown [clientKey]="clientData?.$key"
                                      (selectedLocation)="changeSelectedLocation($event)"
                                      [selectedLocationData]="locationData"></app-select-location-dropdown>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-4 col-sm-offset-2">
        <div class="panel panel-info"
             style="margin-top: 20px;">
          <div class="panel-heading">
            <h3 class="panel-title">Location Info</h3>
          </div>
          <div class="panel-body">
            <h5 class="mt-0 mb-4 p-0"
                style="text-transform:none">{{locationData?.name}}</h5>
            <p>{{locationData?.address}}</p>
            <p>{{locationData?.address2}}</p>
          </div>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="panel panel-primary"
             style="margin-top: 20px;">
          <div class="panel-heading">
            <h3 class="panel-title">Stats</h3>
          </div>
          <div class="panel-body">
            <div class="row"
                 *ngIf="locationData?.managersName">
              <div class="col-sm-6">
                <p><b>Managers Name:</b> </p>
              </div>
              <div class="col-sm-6">
                <p>{{locationData?.managersName}}</p>
              </div>
            </div>
            <hr *ngIf="locationData?.managersName">
            <div class="row"
                 *ngIf="locationData?.numUnits">
              <div class="col-sm-6">
                <p><b>Num Units (onboarding):</b> </p>
              </div>
              <div class="col-sm-6">
                <p>{{locationData?.numUnits}}</p>
              </div>
            </div>
            <hr *ngIf="locationData?.numUnits">
            <div *ngIf="locationData?.occupancyRate"
                 class="row">
              <div class="col-sm-6">
                <p><b>Occupancy Rate at Onboarding:</b> </p>
              </div>
              <div class="col-sm-6">
                <p>{{locationData?.occupancyRate}}</p>
              </div>
            </div>
            <hr *ngIf="locationData?.occupancyRate">

            <div class="row">
              <div class="col-sm-6">
                <p><b>Total Units:</b> </p>
              </div>
              <div class="col-sm-6">
                <p>{{totalUnits}}</p>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-sm-6">
                <p><b>Available Units:</b> </p>
              </div>
              <div class="col-sm-6">
                <p>{{availableUnits}}</p>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-sm-6">
                <p><b>Occupancy Rate:</b> </p>
              </div>
              <div class="col-sm-6">
                <p>{{occupancyRate | number:'1.1-2'}}%</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div *ngIf="locationData.onboardingKey"
           class="col-sm-8 col-sm-offset-2 my-4">
        <div class="panel panel-default">
          <div class="panel-heading">
            <h3 class="panel-title">Location Onboarding</h3>
          </div>
          <div class="panel-body">
            <div *ngIf="!locationOnboardingInfo; else locationOnboardingInfoTable"
                 class="text-center">
              <button (click)="getLocationOnboardingInfo()"
                      class="btn-primary btn">
                Show Onboarding Info
              </button>
            </div>
            <ng-template #locationOnboardingInfoTable>
              <accordion class="mb-0">
                <accordion-group heading="Onboarding Info"
                                 [isOpen]="false">
                  <div style="max-height: 400px; overflow-y: auto;">
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th>label</th>
                          <th>value</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let i of locationOnboardingInfo.hubspot">
                          <td>{{i.key}}</td>
                          <td>{{i.val}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </accordion-group>
                <accordion-group heading="Initial Location Info">
                  <div style="max-height: 400px; overflow-y: auto;">
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th>label</th>
                          <th>value</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let i of locationOnboardingInfo.locationInformation">
                          <td>{{i.key}}</td>
                          <td>{{i.val}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </accordion-group>
              </accordion>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
    <div class="row margin-bottom">
      <div class="col-md-12 button-wrapper">
        <div class="btn-group center-block">
          <label class="btn btn-default btn-lg"
                 name="radioModel"
                 btnRadio="warm"
                 uncheckable
                 [routerLink]="['/' + path + '/settings/create-leases']">
            <em class="icon-book-open"></em>&nbsp;&nbsp;eSign Form Settings</label>
          <label class="btn btn-default btn-lg"
                 name="radioModel"
                 btnRadio="warm"
                 uncheckable
                 [routerLink]="['/' + path + '/settings/component']">
            <em class="icon-folder"></em>&nbsp;&nbsp;Component Settings</label>
          <label class="btn btn-default btn-lg"
                 name="radioModel"
                 btnRadio="warm"
                 uncheckable
                 [routerLink]="['/' + path + '/settings/size-guide']">
            <em class="icon-calculator "></em>&nbsp;&nbsp;Size Guide</label>
          <label class="btn btn-default btn-lg"
                 name="radioModel"
                 btnRadio="warm"
                 uncheckable
                 [routerLink]="['/' + path + '/settings/portable-settings']">
            <em class="icon-rocket "></em>&nbsp;&nbsp;Portable Settings</label>
          <label class="btn btn-default btn-lg"
                 name="radioModel"
                 btnRadio="cold"
                 uncheckable
                 [routerLink]="['/' + path + '/settings/checkout-settings']">
            <em class="icon-wallet "></em>&nbsp;&nbsp;Checkout Charges</label>
        </div>
      </div>
    </div>

    <!-- <div class="row">
      <div class="col-xs-6">
        <h3>{{(location | async)?.name}}
          <br>{{(location | async)?.tagLine}}
          <br>{{(location | async)?.email}}</h3>
      </div>
      <div class="col-xs-6">
        <h3>
          {{(location | async)?.address}}
          <br> {{(location | async)?.address2}}
          <br> {{(location | async)?.phone}}
          <br>
        </h3>
      </div>
    </div> -->
    <md-card-header>
      <md-card-title>
        <h2>Location Settings</h2>
      </md-card-title>
    </md-card-header>

    <div class="ui-grid ui-grid-responsive ui-fluid"
         *ngIf="locationData">
      <div class="row sm-padding-top">
        <div class="col-md-6">
          <label for="name">Name</label>
          <input pInputText
                 id="name"
                 (change)="updateLocation()"
                 [(ngModel)]="locationData.name" />
        </div>
        <div class="col-md-6">
          <label for="tagLine">Tag Line</label>
          <input pInputText
                 id="tagLine"
                 (change)="updateLocation()"
                 [(ngModel)]="locationData.tagLine" />

        </div>
      </div>

      <div class="row sm-padding-top">
        <div class="col-md-6">
          <label for="address">Address</label>
          <input pInputText
                 id="address"
                 (change)="updateLocation()"
                 [(ngModel)]="locationData.address" />
        </div>
        <div class="col-md-6">
          <label for="address2">[City], [State] [Zip]</label>
          <input pInputText
                 id="address2"
                 (change)="updateLocation()"
                 [(ngModel)]="locationData.address2" />
        </div>
      </div>
      <div class="row sm-padding-top">
        <div class="col-md-6">
          <label for="phone">Phone</label>
          <p-inputMask id="phone"
                       mask="(***) ***-****"
                       (change)="updateLocation()"
                       [(ngModel)]="locationData.phone"></p-inputMask>
        </div>
        <div class="col-md-6">
          <label for="smsPhone">SMS Phone</label>
          <p-inputMask id="smsPhone"
                       mask="(***) ***-****"
                       (change)="updateLocation()"
                       [(ngModel)]="locationData.smsPhone"></p-inputMask>
        </div>
      </div>
      <div class="row sm-padding-top">
        <div class="col-md-6">
          <label for="email">Email</label>
          <input pInputText
                 id="email"
                 (change)="updateLocation()"
                 [(ngModel)]="locationData.email" />

          <label for="locationLogo">Location Logo URL</label>
          <input pInputText
                 id="locationLogo"
                 (change)="updateLocation()"
                 [(ngModel)]="locationData.logoUrl" />
          <img *ngIf="locationData.logoUrl"
               [src]="locationData.logoUrl"
               style="display:block;max-height:100px">
          <label for="locationLogoSquare">Location Logo Square URL</label>
          <input pInputText
                 id="locationLogoSquare"
                 (change)="updateLocation()"
                 [(ngModel)]="locationData.squareLogoUrl" />
          <img *ngIf="locationData.squareLogoUrl"
               [src]="locationData.squareLogoUrl"
               style="display:block;max-height:100px">
        </div>
        <div class="col-md-6">
          <label for="imageUrl">Location Image URL</label>
          <input pInputText
                 id="imageUrl"
                 (change)="updateLocation()"
                 [(ngModel)]="locationData.imageUrl" />
          <label for="imageAlt">Location Image Alt</label>
          <input pInputText
                 id="imageAlt"
                 (change)="updateLocation()"
                 [(ngModel)]="locationData.imageAlt" />
          <label for="imageTitle">Location Image Title</label>
          <input pInputText
                 id="imageTitle"
                 (change)="updateLocation()"
                 [(ngModel)]="locationData.imageTitle" />
          <label for="latitude">Rates Header</label>
          <input name="rates-header"
                 pInputText
                 id="ratesHeader"
                 (change)="updateLocation()"
                 [(ngModel)]="locationData.ratesHeader" />
        </div>
      </div>
      <div class="row sm-padding-top">
        <div class="col-md-3">
          <label for="latitude">Latitude</label>
          <input name="lat"
                 pInputText
                 id="latitude"
                 (change)="updateLocation()"
                 [(ngModel)]="locationData.latitude" />
          <label for="longitude">Longitude</label>
          <input name="long"
                 pInputText
                 id="longitude"
                 (change)="updateLocation()"
                 [(ngModel)]="locationData.longitude" />
        </div>
        <div class="col-md-3">
          <button type="button"
                  class="btn btn-accent"
                  color="accent"
                  (change)="updateLocation()"
                  (click)="getLatLong()">Get Lat/Long</button>
        </div>
      </div>
      <br>
      <br>
      <hr>
      <h4>Location Home Page HTML Row(s)</h4>
      <md-slide-toggle id="sliderAutoPlay"
                       (change)="updateUseLocationHomePageHtmlRow($event)"
                       [(ngModel)]="locationData.useHomePageHtmlRow">
        Use HTML Row(s) on Location Home Page?
      </md-slide-toggle>
      <br>
      <div [dragula]="'html-rows-bag'"
           [dragulaModel]="locationData.htmlHomePageRows">
        <div class="mb-3 row"
             *ngFor="let row of locationData.htmlHomePageRows; let index = index">
          <h5>HTML Row {{index + 1}}</h5>
          <div class="col-md-11"
               id="viewLocationHomePageHtmlRow-{{index}}"
               [froalaEditor]="options"
               [(froalaModel)]="row.html"></div>

          <button type="button"
                  class="btn btn-danger col-md-1"
                  (click)="deleteHTMLRow(index)">X</button>
        </div>
      </div>
      <br>
      <div class="row">
        <div class="col-md-4">
          <button type="button"
                  class="btn btn-primary"
                  color="primary"
                  style="float:left; max-width: 75px;"
                  (click)="showHTMLRowsToAdd()">
            <i class="fa fa-plus"
               aria-hidden="true"></i> Add
          </button>
        </div>
        <div class="col-md-4">
          <button type="button"
                  class="btn btn-accent"
                  color="accent"
                  (click)="updateLocation()">
            <i class="fa fa-check"
               aria-hidden="true"></i> Save</button>
        </div>
      </div>
      <br>
      <br>
      <hr>
      <!-- <br>
      <h5 class="text-center">Edit Location Specific Metadata</h5>
      <scs-navigation-item [locationData]="afService.locationData"
                           [clientData]="clientData"
                           [navItems]="navItems"></scs-navigation-item> -->
      <br>
      <div class="row sm-padding-top">
        <div class="col-md-12">
          <h4>Location Login Metadata</h4>
          <div class="row">
            <div class="col-xs-12">
              <md-slide-toggle id="showMetaData"
                               [(ngModel)]="locationData.loginPageShowMetaData"
                               (change)="toggleLoginMetaData($event)">Show login meta data</md-slide-toggle>
            </div>
          </div>
          <div class="row"
               *ngIf="locationData.loginPageShowMetaData">
            <div class="col-xs-12 col-md-6 sm-margin-top">
              <label>Meta Title</label>
              <input pInputText
                     (change)="updateLocation()"
                     [(ngModel)]="locationData.loginPage.metaTitle" />
            </div>
            <div class="col-xs-12 col-md-6 sm-margin-top">
              <p>
                <b>Location image is used by default. If you put one here it overides that.</b>
              </p>
              <label>Meta Image</label>
              <input pInputText
                     (change)="updateLocation()"
                     [(ngModel)]="locationData.loginPage.metaImage" />
            </div>
            <div class="col-xs-12 col-md-6 sm-margin-top">
              <label>Meta Image Alt</label>
              <input pInputText
                     (change)="updateLocation()"
                     [(ngModel)]="locationData.loginPage.metaImageAlt" />
            </div>
            <div class="col-xs-12 col-md-6 sm-margin-top">
              <label>Meta Description</label>
              <textarea pInputTextarea
                        (change)="updateLocation()"
                        class="full-width text-area-box"
                        [(ngModel)]="locationData.loginPage.metaDescription"></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="row sm-padding-top">
        <div class="col-md-12">
          <h4>Location Home Page Metadata</h4>
          <div class="row">
            <div class="col-xs-12 col-md-6 sm-margin-top">
              <label>Meta Title</label>
              <input pInputText
                     (change)="updateLocation()"
                     [(ngModel)]="locationData.metaTitle" />
            </div>
            <div class="col-xs-12 col-md-6 sm-margin-top">
              <p>
                <b>Location image is used by default. If you put one here it overides that.</b>
              </p>
              <label>Meta Image</label>
              <input pInputText
                     (change)="updateLocation()"
                     [(ngModel)]="locationData.metaImage" />
            </div>
            <div class="col-xs-12 col-md-6 sm-margin-top">
              <label>Meta Image Alt</label>
              <input pInputText
                     (change)="updateLocation()"
                     [(ngModel)]="locationData.metaImageAlt" />
            </div>
            <div class="col-xs-12 col-md-6 sm-margin-top">
              <label>Meta Description</label>
              <textarea pInputTextarea
                        (change)="updateLocation()"
                        class="full-width text-area-box"
                        [(ngModel)]="locationData.metaDescription"></textarea>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="row sm-padding-top">
        <div class="col-md-12">
          <h4>Location Unit Page Metadata</h4>
          <div class="row">
            <div class="col-xs-12 col-md-6 sm-margin-top">
              <label>Meta Title</label>
              <input pInputText
                     (change)="updateLocation()"
                     [(ngModel)]="locationData.unitsPage.metaTitle" />
            </div>
            <div class="col-xs-12 col-md-6 sm-margin-top">
              <p>
                <b>Location image is used by default. If you put one here it overides that.</b>
              </p>
              <label>Meta Image</label>
              <input pInputText
                     (change)="updateLocation()"
                     [(ngModel)]="locationData.unitsPage.metaImage" />
            </div>
            <div class="col-xs-12 col-md-6 sm-margin-top">
              <label>Meta Image Alt</label>
              <input pInputText
                     (change)="updateLocation()"
                     [(ngModel)]="locationData.unitsPage.metaImageAlt" />
            </div>
            <div class="col-xs-12 col-md-6 sm-margin-top">
              <label>Meta Description</label>
              <textarea pInputTextarea
                        (change)="updateLocation()"
                        class="full-width text-area-box"
                        [(ngModel)]="locationData.unitsPage.metaDescription"></textarea>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="row sm-padding-top">
        <div class="col-md-12">
          <h4>This location is no integration</h4>
        </div>
        <div class="col-md-12">
          <md-slide-toggle id="isNoIntegration"
                           (change)="updateIsNoIntegration($event)"
                           [(ngModel)]="locationData.isNoIntegration">No Integration</md-slide-toggle>
        </div>
        <div class="col-md-12">
          <h4>Disable Customer Portal</h4>
        </div>
        <div class="col-md-12">
          <md-slide-toggle id="disableCustomerPortal"
                           (change)="updateDisableCustomerPortal($event)"
                           [(ngModel)]="locationData.disableCustomerPortal">No Customer Portal
          </md-slide-toggle>
        </div>
        <div *ngIf="locationData.disableCustomerPortal"
             class="col-md-12">
          <label for="disabledCustomerPortalText">Disabled Customer Portal Text</label>
          <textarea id="disabledCustomerPortalText"
                    [froalaEditor]="options"
                    [(froalaModel)]="locationData.disabledCustomerPortalText"></textarea>
          <div class="my-4">
            <button type="button"
                    class="btn btn-accent"
                    color="accent"
                    (click)="updateLocation()">
              <i class="fa fa-check"
                 aria-hidden="true"></i> Save</button>
          </div>
        </div>
      </div>
      <div *ngIf="!locationData.isNoIntegration && clientData.propertySoftware == 'uhaul'">
        <div class="row sm-padding-top">
          <div class="col-md-12">
            <h4>Uhaul Information</h4>
          </div>
          <div class="col-md-6">
            <label for="siteLinkCorpCode">Location Code</label>
            <input pInputText
                   id="uhaulLocationKey"
                   (change)="updateLocation()"
                   [(ngModel)]="locationData.uhaulLocationKey" />
          </div>
          <div class="col-md-6">
            <label for="useUhaulImages">Unit Images</label>
            <md-slide-toggle id="useUhaulImages"
                             (change)="updateUhaulImages($event)"
                             [(ngModel)]="locationData.useUhaulImages">Use Uhaul Images</md-slide-toggle>
          </div>
        </div>
      </div>
      <div class="row sm-padding-top">
        <div class="col-md-4"
             *ngIf="!locationData.isNoIntegration && clientData.propertySoftware == 'sitelink'">
          <h4>Sitelink Information</h4>
          <hr>
          <label for="siteLinkCorpCode">Corp Code</label>
          <input pInputText
                 id="siteLinkCorpCode"
                 (change)="updateLocation(); sitelinkCredsValid = null"
                 [(ngModel)]="locationData.siteLinkCorpCode" />
          <label for="siteLinkLocationCode">Location Code</label>
          <input pInputText
                 id="siteLinkLocationCode"
                 (change)="updateLocation(); sitelinkCredsValid = null"
                 [(ngModel)]="locationData.siteLinkLocationCode" />
          <!-- <label for="siteLinkLicenseKey">License Key</label>
          <input pInputText
                 id="siteLinkLicenseKey"
                 (change)="updateLocation(); sitelinkCredsValid = null"
                 [(ngModel)]="locationData.siteLinkLicenseKey" /> -->
          <label for="siteLinkCorpUsername">Corp Username</label>
          <input pInputText
                 id="siteLinkCorpUsername"
                 (change)="updateLocation(); sitelinkCredsValid = null"
                 [(ngModel)]="locationData.siteLinkCorpUsername" />
          <label for="siteLinkLocationPw">Location Password</label>
          <input pInputText
                 id="siteLinkLocationPw"
                 (change)="updateLocation(); sitelinkCredsValid = null"
                 [(ngModel)]="locationData.siteLinkLocationPw" />
          <br>
          <div *ngIf="sitelinkCredsValid !== null"
               class="sm-padding-top d-flex flex-wrap align-content-center justify-content-center">
            <div *ngIf="sitelinkCredsValid; else invalidSitelinkCreds"
                 class="success">
              Sitelink creds are valid
            </div>
            <ng-template #invalidSitelinkCreds>
              <div class="error">
                Sitelink creds are invalid
              </div>
            </ng-template>
          </div>
          <div class="pt-4 d-flex align-items-center justify-content-center flex-wrap">
            <button class="btn btn-primary"
                    color="primary"
                    (click)="fillSitelinkDemoDetails()">Fill Demo Details</button>
            <button class="btn btn-secondary ml-auto"
                    (click)="verifySitelinkCreds()">Verify Sitelink Creds</button>
          </div>
        </div>
        <div class="col-md-8">
          <h4>Location Home separator bar</h4>
          <hr>
          <!--   <md-slide-toggle id="showSeparatorbar"
                           color="primary"
                           [(ngModel)]="locationData.showSeparatorbar"
                           (change)="toggleseparatorBar($event)">Show separator Bar</md-slide-toggle> -->
          <br>
          <label for="separatorTitle">Title</label>
          <input pInputText
                 id="separatorTitle"
                 (change)="updateLocation()"
                 [(ngModel)]="locationData.separatorTitle" />
          <br>
          <label for="separatorText">Text</label>
          <div id="separatorText"
               [froalaEditor]="options"
               [(froalaModel)]="locationData.separatorText"></div>
          <br>
          <button type="button"
                  class="btn btn-accent"
                  color="accent"
                  (click)="updateLocation()">
            <i class="fa fa-check"
               aria-hidden="true"></i> Save</button>
          <h4>Location Home Features bar</h4>
          <label for="featuresTitle">Title</label>
          <input pInputText
                 id="featuresTitle"
                 (change)="updateLocation()"
                 [(ngModel)]="locationData.featuresTitle" />
          <label for="featuresSubtitle">Subitle</label>
          <input pInputText
                 id="featuresSubtitle"
                 (change)="updateLocation()"
                 [(ngModel)]="locationData.featuresSubtitle" />
          <hr>
        </div>

      </div>

    </div>
    <hr>

    <div class="row sm-padding-top">
      <div class="col-md-7">
        <h4>View All Units About Location (bottom of page or sidebar)</h4>
        <div id="aboutLocationText"
             [froalaEditor]="options"
             [(froalaModel)]="locationData.aboutLocationText"></div>
        <br>
        <button type="button"
                class="btn btn-accent"
                color="accent"
                (click)="updateLocation()">
          <i class="fa fa-check"
             aria-hidden="true"></i> Save</button>
        <br>
        <br>
        <md-slide-toggle id="sliderAutoPlay"
                         (change)="updateAboutLocationSidebarSlider($event)"
                         [(ngModel)]="locationData.aboutLocationSidebarSlider">
          Use the location slides for the image instead of the below option
        </md-slide-toggle>
        <label for="aboutLocationSidebarImage">Sidebar Image (if different than location image)</label>
        <input pInputText
               id="aboutLocationSidebarImage"
               class="full-width"
               (change)="updateLocation()"
               [(ngModel)]="locationData.aboutLocationSidebarImage" />
        <label for="aboutLocationSidebarImageTitle">Sidebar Image Title</label>
        <input pInputText
               id="aboutLocationSidebarImageTitle"
               class="full-width"
               (change)="updateLocation()"
               [(ngModel)]="locationData.aboutLocationSidebarImageTitle" />
        <label for="aboutLocationSidebarImageAlt">Sidebar Image Alt</label>
        <input pInputText
               id="aboutLocationSidebarImageAlt"
               class="full-width"
               (change)="updateLocation()"
               [(ngModel)]="locationData.aboutLocationSidebarImageAlt" />
        <br>
        <br>
        <h4>View All Units HTML Row</h4>
        <md-slide-toggle id="useHtmlRow"
                         (change)="updateUseHtmlRow($event)"
                         [(ngModel)]="locationData.useHtmlRow">
          Use HTML Row on Location View Units Page?
        </md-slide-toggle>
        <br>
        <md-slide-toggle id="replaceUnitsWithHtmlRom"
                         (change)="updateReplaceUnitsWithHtmlRow($event)"
                         [(ngModel)]="locationData.replaceUnitsWithHtmlRow">
          Replace units display with the HTML Row on Location View Units Page?
        </md-slide-toggle>
        <br>
        <div id="viewAllUnitsHtmlRow"
             [froalaEditor]="options"
             [(froalaModel)]="locationData.htmlRowHtml"></div>
        <br>
        <button type="button"
                class="btn btn-accent"
                color="accent"
                (click)="updateLocation()">
          <i class="fa fa-check"
             aria-hidden="true"></i> Save</button>



        <hr class="my-5" />
        <div class="row">
          <div class="col-xs-12 my-3">
            <h3>Coming Soon Information</h3>
            <md-slide-toggle [(ngModel)]="locationData.isNotOpen"
                             (change)="updateIsNotOpen($event)">This location is not open (therefore it is coming soon,
              etc.)
            </md-slide-toggle>
            <p>This setting removes units, adds the html row, and, if the html row is blank, adds a default coming soon
              message. The customer portal is disabled for this location as well.</p>
            <div class="row"
                 *ngIf="locationData.isNotOpen">
              <div class="col-xs-12">
                <label for="opening-date">Opening Date</label>
                <input class="full-width"
                       pInputText
                       id="opening-date"
                       [(ngModel)]="locationData?.comingSoonInfo.headerDate" />
              </div>
              <div class="col-xs-12">
                <label for="row-title">Row Title</label>
                <input class="full-width"
                       pInputText
                       id="row-title"
                       [(ngModel)]="locationData?.comingSoonInfo.title" />
              </div>
              <div class="col-xs-12">
                <label for="row-image">Row Image URL</label>
                <input class="full-width"
                       pInputText
                       id="row-image"
                       [(ngModel)]="locationData?.comingSoonInfo.imageUrl" />
              </div>
              <div class="col-xs-12">
                <label for="row-layout">Row Layout</label>
                <select class="form-control"
                        id="row-layout"
                        name="row-layout-select"
                        value="imageLeft"
                        [(ngModel)]="locationData?.comingSoonInfo.layout">
                  <option *ngFor="let layout of rowLayoutOptions"
                          [value]="layout.value">{{layout.label}}</option>
                </select>
              </div>
              <div class="col-xs-12">
                <p>HTML</p>
                <textarea [froalaEditor]="options"
                          [(froalaModel)]="locationData.comingSoonInfo.html"
                          class="full-width"></textarea>
              </div>
            </div>
            <div class="mt-3"
                 *ngIf="locationData.isNotOpen">
              <label>Contact Us Title</label>
              <input pInputText
                     class="col-md-12"
                     [(ngModel)]="locationData?.comingSoonInfo.contactUsTitle" />
            </div>
            <div class="clear mt-3"
                 *ngIf="locationData.isNotOpen">
              <label>Contact Us Subtitle</label>
              <input pInputText
                     class="col-md-12"
                     [(ngModel)]="locationData?.comingSoonInfo.contactUsSubtitle" />
            </div>
            <button type="button"
                    *ngIf="locationData.isNotOpen"
                    class="btn btn-primary mt-3 mb-5"
                    (click)="updateLocation()">Save Coming Soon</button>
          </div>
        </div>
        <br>
      </div>
      <div class="col-md-5">
        <h4>View All units sidebar features</h4>
        <div *ngFor="let link of locationData.aboutLocationFeaturesArray; let index = index">
          <input pInputText
                 style="display:inline-block;margin-top:15px;width:70%"
                 placeholder="New Feature"
                 [(ngModel)]="locationData.aboutLocationFeaturesArray[index].name" />
          <button type="button"
                  class="btn btn-danger"
                  style="margin-left:5%;width:10%"
                  (click)="removeFeature(index)">X</button>
        </div>

        <button type="button"
                class="btn btn-accent"
                style="margin-top:15px;"
                (click)="locationData.aboutLocationFeaturesArray.push({name: ''})">Add Feature</button>
        <button type="button"
                class="btn btn-primary"
                style="margin-top:15px;"
                (click)="updateLocation()">Save Features</button>
        <button type="button"
                class="btn btn-default"
                style="margin-top:15px;"
                (click)="addFacilityFeatures()">Copy From Features Component</button>
      </div>
    </div>
    <div class="row sm-padding-top">
      <div style="max-height:500px;overflow:auto"
           class="col-md-12">
        <h4>View All units sidebar/tab box sections</h4>
        <div *ngFor="let section of locationData.locationsCustomSidebarArray; let index = index">
          <div>
            <input pInputText
                   style="display:inline-block;margin-top:15px;width:70%"
                   placeholder="Title"
                   [(ngModel)]="locationData.locationsCustomSidebarArray[index].title" />
            <button type="button"
                    class="btn btn-danger"
                    style="margin-left:5%;width:10%"
                    (click)="removeSidebarSection(index)">X</button>
          </div>
          <div id="locationsCustomSidebarArray{{index}}"
               [froalaEditor]="optionsNoSticky"
               [(froalaModel)]="locationData.locationsCustomSidebarArray[index].body"></div>
        </div>
      </div>
      <div class="col-md-12">
        <button type="button"
                class="btn btn-accent"
                style="margin-top:15px;"
                (click)="locationData.locationsCustomSidebarArray.push({title: '', id: '', body: ''})">Add
          Section</button>
        <button type="button"
                class="btn btn-primary"
                style="margin-top:15px;"
                (click)="saveSidebarSections()">Save Sections</button>
      </div>
    </div>
    <div class="row sm-padding-top">
      <div class="col-md-6">
        <h4>Full Occupancy Message</h4>
        <div class="my-5">
          <span class="ui-float-label">
            <input (change)="updateLocation()"
                   [(ngModel)]="locationData.fullyOccupiedMessageTitle"
                   id="float-input-0"
                   type="text"
                   size="30"
                   pInputText>
            <label for="float-input-0">Title</label>
          </span>
        </div>
        <div class="my-5">
          <span class="ui-float-label">
            <input (change)="updateLocation()"
                   [(ngModel)]="locationData.fullyOccupiedMessageSubtitle"
                   id="float-input-1"
                   type="text"
                   size="30"
                   pInputText>
            <label for="float-input-1">Subtitle</label>
          </span>
        </div>
        <div class="my-5">
          <span class="ui-float-label">
            <input (change)="updateLocation()"
                   [(ngModel)]="locationData.fullyOccupiedMessageButtonText"
                   id="float-input-2"
                   type="text"
                   size="30"
                   pInputText>
            <label for="float-input-2">Contact Button Text</label>
          </span>
        </div>
      </div>
    </div>
    <div class="row sm-padding-top">
      <div class="col-md-6">
        <h4>View All units Location Box Slideshow Settings</h4>
        <button type="button"
                class="btn btn-primary"
                style="margin-top:15px;"
                (click)="copyFromHomeSlides()">Copy from Home Page Slides</button>
        <button type="button"
                class="btn btn-primary"
                style="margin-top:15px;"
                (click)="copyFromLocationSlides()">Copy from Location Slides</button>
        <div class="row sm-padding-top">
          <div class="col-xs-12">
            <md-slide-toggle id="showSliderArrows"
                             (change)="updateLocationBoxShowSliderArrows($event)"
                             [(ngModel)]="locationData.locationBoxSlideshow.showSliderArrows"> Show Arrows
            </md-slide-toggle>

          </div>
          <div class="col-xs-12">
            <md-slide-toggle id="sliderAutoPlay"
                             (change)="updateLocationBoxSliderAutoPlay($event)"
                             [(ngModel)]="locationData.locationBoxSlideshow.sliderAutoPlay"> Autoplay
              Slider</md-slide-toggle>
          </div>
          <div class="col-xs-12 my-5">
            <label>Slider Header URLs</label>
            <app-slideshow (onSave)="updateLocation()"
                           [(slides)]="locationData?.locationBoxSlideshow.sliderUrls"
                           [showSliderArrows]="locationData?.locationBoxSlideshow?.showSliderArrows"
                           [sliderAutoPlay]="locationData?.locationBoxSlideshow?.sliderAutoPlay"></app-slideshow>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <h4>Reserve Process HTML Row</h4>
        <md-slide-toggle id="sliderAutoPlay"
                         (change)="updateUseHtmlRow($event)"
                         [(ngModel)]="locationData.useHtmlRowReserveProcess">
          Use HTML Row on top of Reservation process?
        </md-slide-toggle>
        <br>
        <div id="htmlRowReserveProcessHtml"
             [froalaEditor]="options"
             [(froalaModel)]="locationData.htmlRowReserveProcessHtml"></div>
        <br>
        <button type="button"
                class="btn btn-accent"
                color="accent"
                (click)="updateLocation()">
          <i class="fa fa-check"
             aria-hidden="true"></i> Save</button>
      </div>
      <div class="col-sm-6">
        <h4>Rental Process HTML Row</h4>
        <md-slide-toggle id="sliderAutoPlay"
                         (change)="updateUseHtmlRow($event)"
                         [(ngModel)]="locationData.useHtmlRowRentalProcess">
          Use HTML Row on top of Rental process?
        </md-slide-toggle>
        <br>
        <div id="htmlRowRentalProcessHtml"
             [froalaEditor]="options"
             [(froalaModel)]="locationData.htmlRowRentalProcessHtml"></div>
        <br>
        <button type="button"
                class="btn btn-accent"
                color="accent"
                (click)="updateLocation()">
          <i class="fa fa-check"
             aria-hidden="true"></i> Save</button>
      </div>
    </div>
    <hr>

    <md-card-header>
      <md-card-title>
        <h3>Settings</h3>
      </md-card-title>
    </md-card-header>

    <div class="row sm-padding-top">
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-12">
            <md-slide-toggle id="enableDiscountBlurb"
                             color="primary"
                             [(ngModel)]="locationData.enableDiscountBlurb"
                             (change)="updateDiscountBlurb($event)">Enable Discount Blurb
            </md-slide-toggle>
            <div *ngIf="locationData.enableDiscountBlurb"
                 class="col-xs-12 my-4">
              <span class="ui-float-label">
                <input (change)="updateLocation()"
                       [(ngModel)]="locationData.discountBlurbText"
                       id="float-input"
                       type="text"
                       size="30"
                       pInputText>
                <label for="float-input">Discount Blurb Text</label>
              </span>
            </div>
            <br>
            <br>
            <md-slide-toggle id="isAutoPayAtMoveIn"
                             color="primary"
                             [(ngModel)]="locationData.isAutoPayAtMoveIn"
                             (change)="updateAutoPayAtMoveIn($event)">Enable AutoPay Automatically at Move In
            </md-slide-toggle>
            <br>
            <br>
            <md-slide-toggle id="smsReminders"
                             color="primary"
                             [(ngModel)]="locationData.isSmsReminders"
                             (change)="updateSmsReminders($event)">Show SMS Opt in on Move-in form?
            </md-slide-toggle>
            <br>
            <br>
            <md-slide-toggle id="forceSmsOptIn"
                             color="primary"
                             [(ngModel)]="locationData.forceSmsOptIn"
                             (change)="updateForceSmsOptIn($event)">Force SMS Opt during Move-in (overwrites above)?
            </md-slide-toggle>
            <br>
            <br>
            <md-slide-toggle id="showInsuranceOptions"
                             color="primary"
                             [(ngModel)]="locationData.showInsuranceOptions"
                             (change)="updateShowInsuranceOptions($event)">
              Show insurance options when renting a unit?
            </md-slide-toggle>
            <br>
            <br>
            <md-slide-toggle id="showInsuranceDescriptions"
                             color="primary"
                             [(ngModel)]="locationData.showInsuranceDescriptions"
                             (change)="updateShowInsuranceDescriptions($event)">
              Show insurance descriptions?
            </md-slide-toggle>
            <br>
            <br>
            <md-slide-toggle id="requireInsurance"
                             color="primary"
                             [(ngModel)]="locationData.requireInsurance"
                             (change)="updateRequireInsurance($event)">Require insurance?</md-slide-toggle>
            <br>
            <br>
            <md-slide-toggle id="allowHomeInsurancePolicy"
                             color="primary"
                             [(ngModel)]="locationData.allowHomeInsurancePolicy"
                             (change)="updateAllowHomeInsurancePolicy($event)">Allow use of home insurance?
            </md-slide-toggle>
            <br>
            <br>
            <md-slide-toggle id="showInsuranceOptions"
                             color="primary"
                             [(ngModel)]="locationData.hideInsuranceForParkingAndOffices"
                             (change)="updateHideInsuranceForParkingAndOffices($event)">Hide insurance options for
              parking/office suites?</md-slide-toggle>
            <br>
            <br>
            <md-slide-toggle id="sortParkingLast"
                             color="primary"
                             [(ngModel)]="locationData.sortParkingLast"
                             (change)="updateSortParkingLast($event)">Show parking units last?</md-slide-toggle>
            <br>
            <br>
            <md-slide-toggle id="sortByUnitType"
                             color="primary"
                             [(ngModel)]="locationData.sortByUnitType"
                             (change)="updateSortByUnitType($event)">Sort units by Unit Type Name?</md-slide-toggle>
            <br>
            <br>
            <md-slide-toggle id="hasInsuranceMaxCoverageAmount"
                             color="primary"
                             [(ngModel)]="locationData.hasInsuranceMaxCoverageAmount"
                             (change)="updateHasInsuranceMaxCoverageAmount($event)">Hide insurance coverage over an
              amount?</md-slide-toggle>
            <br>
            <br>
            <ng-container *ngIf="locationData.hasInsuranceMaxCoverageAmount">
              <label for="insuranceMaxCoverageAmount">Insurance Max Coverage Amount</label>
              <input (change)="updateLocation()"
                     pInputText
                     type="number"
                     id="insuranceMaxCoverageAmount"
                     class="full-width"
                     [(ngModel)]="locationData.insuranceMaxCoverageAmount" />
              <br>
              <br>
            </ng-container>
            <md-slide-toggle id="showProtectionPlanInstead"
                             color="primary"
                             [(ngModel)]="locationData.showProtectionPlanInstead"
                             (change)="updateShowProtectionPlanInstead($event)">Say "Protection Plan" instead of
              "Insurance"</md-slide-toggle>
            <br>
            <br>
            <!-- <br *ngIf="locationData.showInsuranceOptions == true">
            <br *ngIf="locationData.showInsuranceOptions == true">
            <label *ngIf="locationData.showInsuranceOptions == true" for="insuranceHelpText">Insurance Help Text</label>
            <div *ngIf="locationData.showInsuranceOptions == true" id="insuranceHelpText" [froalaEditor]="options2" [(froalaModel)]="locationData.insuranceHelpText"></div>
            <br *ngIf="locationData.showInsuranceOptions == true">
            <button type="button" *ngIf="locationData.showInsuranceOptions == true" class="btn btn-accent" color="accent" (click)="updateLocation()"><i class="fa fa-check" aria-hidden="true"></i> Save</button>

            <br *ngIf="locationData.showInsuranceOptions == true"> -->
            <md-slide-toggle color="primary"
                             [(ngModel)]="locationData.showReserveUnitsOption"
                             (change)="updateShowReserveUnitsOption($event)">Enable reservations?
            </md-slide-toggle>

            <br>
            <br>
            <md-slide-toggle [(ngModel)]="locationData.generateRandomGateCode"
                             (change)="updateGateCode($event)">Generate Random Gate Code?</md-slide-toggle>
            <br>
            <p>Gate Code Min length</p>
            <p-spinner [(ngModel)]="locationData.gateCodeMinLength"
                       (onChange)="updateLocation()"
                       [min]="0"></p-spinner>
            <p>Gate Code Max length</p>
            <p-spinner [(ngModel)]="locationData.gateCodeMaxLength"
                       (onChange)="updateLocation()"
                       [min]="0"></p-spinner>
            <div>
              <md-slide-toggle class="sm-padding-top"
                               (change)="updateGateCodeMaxValue($event)"
                               [(ngModel)]="locationData.useGateCodeMaxValue">Use Gate Code Max Value?
              </md-slide-toggle>
            </div>
            <div *ngIf="locationData.useGateCodeMaxValue">
              <label for="gate-code-max-value">Gate Code Max Value</label>
              <input class="full-width"
                     pInputText
                     type="number"
                     (change)="updateLocation()"
                     id="gate-code-max-value"
                     [(ngModel)]="locationData.gateCodeMaxValue" />
            </div>
            <div>
              <md-slide-toggle class="sm-padding-top"
                               (change)="updateGateCodeMinValue($event)"
                               [(ngModel)]="locationData.useGateCodeMinValue">Use Gate Code Min Value?
              </md-slide-toggle>
            </div>
            <br>
            <div *ngIf="locationData.useGateCodeMinValue">
              <label for="gate-code-min-value">Gate Code Min Value</label>
              <input class="full-width"
                     pInputText
                     (change)="updateLocation()"
                     type="number"
                     id="gate-code-min-value"
                     [(ngModel)]="locationData.gateCodeMinValue" />
            </div>
            <label for="gate-code-blurb">Gate Code Blurb</label>
            <input class="full-width"
                   pInputText
                   (change)="updateLocation()"
                   type="text"
                   id="gate-code-blurb"
                   [(ngModel)]="locationData.accessCodeBlurb" />
            <br>
            <br>
            <md-slide-toggle [(ngModel)]="locationData.noOffice"
                             (change)="updateNoOffice($event)">Hide office blurb in rental email?</md-slide-toggle>
            <br>
            <br>
            <md-slide-toggle [(ngModel)]="locationData.parkingVariables"
                             (change)="updateParkingVariables($event)">Parked Vehicle Info on Lease?</md-slide-toggle>
            <br>
            <br>
            <md-slide-toggle [(ngModel)]="locationData.spaceInsteadOfUnit"
                             (change)="updateSpaceInsteadOfUnit($event)">Use the word "Space" instead of "Unit"
            </md-slide-toggle>
            <br>
            <br>
            <div *ngIf="locationData.parkingVariables">
              <md-slide-toggle [(ngModel)]="locationData.parkingLienInfo"
                               (change)="updateParkingLienInfo($event)">Parked Vehicle Lien Info on Lease?
              </md-slide-toggle>
              <br>
              <br>
              <md-slide-toggle [(ngModel)]="locationData.parkingElectricity"
                               (change)="updateparkingElectricity($event)">Parked Vehicle Electricity on Lease?
              </md-slide-toggle>
              <br>
              <br>
            </div>
            <md-slide-toggle [(ngModel)]="locationData.reservationFee"
                             (change)="updateReservationFee($event)">Reservation Fee?</md-slide-toggle>
            <!-- <br>
            <br>
            <md-slide-toggle [(ngModel)]="locationData.showCheckoutItem"
                             (change)="updateShowCheckoutItem($event)">Show free item in checkout charges?
            </md-slide-toggle>
            <br>
            <br>
            <div *ngIf="locationData.showCheckoutItem">
              <label for="checkout-item">Checkout Item</label>
              <input class="full-width"
                     pInputText
                     (change)="updateLocation()"
                     id="checkout-item"
                     [(ngModel)]="locationData.checkoutItem" />
            </div> -->

            <label for="reviewLink">Review Link</label>
            <input (change)="updateLocation()"
                   pInputText
                   id="reviewLink"
                   class="full-width"
                   [(ngModel)]="locationData.reviewLink" />

            <br>
            <br>
            <div>
              <md-slide-toggle class="sm-padding-top"
                               (change)="updateReservationUseShortMoveInForm($event)"
                               [(ngModel)]="locationData.reservationUseShortMoveInForm">
                Use short move-in form for
                reservations?
              </md-slide-toggle>
            </div>
            <div>
              <md-slide-toggle class="sm-padding-top"
                               (change)="updateRentalsUseShortMoveInForm($event)"
                               [(ngModel)]="locationData.rentalsUseShortMoveInForm">
                Use short move-in form for
                rentals? (new rental flow only)
              </md-slide-toggle>
            </div>
            <div>
              <md-slide-toggle class="sm-padding-top"
                               (change)="updateHideReservationsOnUrgency($event)"
                               [(ngModel)]="locationData.hideReservationsOnUrgency">
                Hide reservations if urgency badge is showing? (Only works on new view units)
              </md-slide-toggle>
            </div>
            <div>
              <md-slide-toggle class="sm-padding-top"
                               (change)="updateReservationUseDatePicker($event)"
                               [(ngModel)]="locationData.reservationUseDatePicker"> Use date picker for
                reservations?
              </md-slide-toggle>
            </div>
            <div>
              <p>Days a reservation is valid.</p>
              <p-spinner [(ngModel)]="locationData.daysReservationIsValid"
                         (onChange)="updateLocation()"
                         [min]="0"></p-spinner>
            </div>
            <div>
              <p>Days a reservation can be made in advance.</p>
              <p-spinner [(ngModel)]="locationData.daysAReservationCanBeMadeInAdvance"
                         (onChange)="updateLocation()"
                         [min]="0"></p-spinner>
            </div>
            <div>
              <md-slide-toggle class="sm-padding-top"
                               (change)="updateRentalUseDatePicker($event)"
                               [(ngModel)]="locationData.rentalUseDatePicker"> Use date picker for rentals?
              </md-slide-toggle>
            </div>
            <div *ngIf="locationData?.rentalUseDatePicker">
              <p>Days a rental can be made in advance. Note: This number can't be zero because it will
                allow a move-in any number of days in advance.</p>
              <p-spinner [(ngModel)]="locationData.daysARentalCanBeMadeInAdvance"
                         (onChange)="updateLocation()"
                         [min]="1"></p-spinner>
            </div>
            <div>
              <md-slide-toggle class="sm-padding-top"
                               (change)="updateReservationUseLocationDisabledDays($event)"
                               [(ngModel)]="locationData.reservationUseLocationDisabledDays"> Use
                location-specific
                disabled days?
              </md-slide-toggle>
            </div>
            <div *ngIf="locationData?.reservationUseLocationDisabledDays"
                 class="row">
              <div class="col-xs-12 sm-margin-top">
                <strong>Disable Days for Rental/Reservation Date Picker</strong>
              </div>
              <div class="col-xs-12 sm-margin-top">
                <md-slide-toggle (change)="updateDatePickerDisableDays($event, 0)"
                                 [(ngModel)]="locationData.datePickerDisableDays[0]">
                  Sunday
                </md-slide-toggle>
              </div>
              <div class="col-xs-12 sm-margin-top">
                <md-slide-toggle (change)="updateDatePickerDisableDays($event, 1)"
                                 [(ngModel)]="locationData.datePickerDisableDays[1]">
                  Monday
                </md-slide-toggle>
              </div>
              <div class="col-xs-12 sm-margin-top">
                <md-slide-toggle (change)="updateDatePickerDisableDays($event, 2)"
                                 [(ngModel)]="locationData.datePickerDisableDays[2]">
                  Tuesday
                </md-slide-toggle>
              </div>
              <div class="col-xs-12 sm-margin-top">
                <md-slide-toggle (change)="updateDatePickerDisableDays($event, 3)"
                                 [(ngModel)]="locationData.datePickerDisableDays[3]">
                  Wednesday
                </md-slide-toggle>
              </div>
              <div class="col-xs-12 sm-margin-top">
                <md-slide-toggle (change)="updateDatePickerDisableDays($event, 4)"
                                 [(ngModel)]="locationData.datePickerDisableDays[4]">
                  Thursday
                </md-slide-toggle>
              </div>
              <div class="col-xs-12 sm-margin-top">
                <md-slide-toggle (change)="updateDatePickerDisableDays($event, 5)"
                                 [(ngModel)]="locationData.datePickerDisableDays[5]">
                  Friday
                </md-slide-toggle>
              </div>
              <div class="col-xs-12 sm-margin-top">
                <md-slide-toggle (change)="updateDatePickerDisableDays($event, 6)"
                                 [(ngModel)]="locationData.datePickerDisableDays[6]">
                  Saturday
                </md-slide-toggle>
              </div>
            </div>
            <div>
              <md-slide-toggle class="sm-padding-top"
                               (change)="updateDatePickerUseFutureStartDate($event)"
                               [(ngModel)]="locationData.datePickerUseFutureStartDate"> Use future start
                date
                instead
                of current date?
              </md-slide-toggle>
            </div>
            <div *ngIf="locationData?.datePickerUseFutureStartDate">
              <label for="reservation-future-start-date">Rental/Reservation future start date</label>
              <input class="full-width"
                     pInputText
                     type="date"
                     id="reservation-future-start-date"
                     (change)="updateLocation()"
                     placeholder="mm/dd/yyyy"
                     [(ngModel)]="locationData.datePickerFutureStartDate" />
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row row-margin">
          <!--           <div class="col-xs-12">
            <md-slide-toggle [(ngModel)]="locationData.hideClientName"
                             (change)="updateHideClientName($event)">
              Hide Client Name
            </md-slide-toggle>
          </div> -->
          <div class="col-xs-12">
            <md-slide-toggle [(ngModel)]="locationData.hideChangeNameOnPortal"
                             (change)="updateHideChangeNameOnPortal($event)">
              Hide option to change name on payment portal
            </md-slide-toggle>
          </div>
          <div class="col-xs-12">
            <md-slide-toggle [(ngModel)]="locationData.hideChangeEmailOnPortal"
                             (change)="updateHideChangeEmailOnPortal($event)">
              Hide option to change email on payment portal
            </md-slide-toggle>
          </div>
          <div class="col-xs-12">
            <md-slide-toggle [(ngModel)]="locationData.disableTenantUpdateInformation"
                             (change)="updateDisableTenantUpdateInformation($event)">
              Completely remove ability for tenant to update information their info in the portal
            </md-slide-toggle>
          </div>
          <div class="col-xs-12">
            <md-slide-toggle [(ngModel)]="locationData.useBoatIconForParking"
                             (change)="updateUseBoatIconForParking($event)">Use Boat Icon for Parking Instad of "P"
              (doesn't work for Uhaul)</md-slide-toggle>
          </div>
          <div class="col-xs-12">
            <md-slide-toggle [(ngModel)]="locationData.leftToolTip"
                             (change)="updateLeftToolTip($event)">Claim Account Toolip - Code/Phone Number
            </md-slide-toggle>
          </div>
          <div *ngIf="locationData.leftToolTip"
               class="col-xs-12">
            <span class="ui-float-label">
              <input (change)="updateLocation()"
                     [(ngModel)]="locationData.leftToolTipText"
                     id="float-input"
                     type="text"
                     size="30"
                     pInputText>
              <label for="float-input">Tooltip Text</label>
            </span>
          </div>
          <div class="col-xs-12">
            <md-slide-toggle [(ngModel)]="locationData.rightToolTip"
                             (change)="updateRightToolTip($event)">Claim Account Toolip - Unit Number</md-slide-toggle>
          </div>
          <div *ngIf="locationData.rightToolTip"
               class="col-xs-12">
            <span class="ui-float-label">
              <input (change)="updateLocation()"
                     [(ngModel)]="locationData.rightToolTipText"
                     id="float-input"
                     type="text"
                     size="30"
                     pInputText>
              <label for="float-input">Tooltip Text</label>
            </span>
          </div>
        </div>
        <div class="row row-margin">
          <div class="col-xs-12">
            <md-slide-toggle [(ngModel)]="locationData.allowPartialPayments"
                             (change)="updateAllowPartialPayments($event)">Partial Payments Page?</md-slide-toggle>
          </div>
          <div class="col-xs-12">
            <md-slide-toggle [(ngModel)]="locationData.pushRateStrikethroughPricing"
                             (change)="updatePushRateStrikethroughPricing($event)">Push rate strikethrough pricing?
            </md-slide-toggle>
          </div>
          <div class="col-xs-12">
            <md-slide-toggle [(ngModel)]="locationData.showWebRate"
                             (change)="updateShowWebRate($event)">Show a web rate? (must run units cache to show)
            </md-slide-toggle>
          </div>
          <div *ngIf="locationData?.showWebRate"
               class="col-xs-12">
            <label for="webRateMultiplier">Web Rate Multiplier (e.g. 1.2 for 20%)</label>
            <input (change)="updateLocation()"
                   pInputText
                   id="webRateMultiplier"
                   class="full-width"
                   [(ngModel)]="locationData.webRateMultiplier" />
          </div>
          <div *ngIf="locationData?.showWebRate || locationData?.pushRateStrikethroughPricing"
               class="col-xs-12">
            <label for="webRateMultiplier">Web Discount/Push Rate Strikethrough "Discount" Name</label>
            <input (change)="updateLocation()"
                   pInputText
                   id="webRateMultiplier"
                   class="full-width"
                   [(ngModel)]="locationData.webRateName" />
          </div>
          <div class="col-xs-12">
            <label for="climateControlledText">Climate Controlled Text</label>
            <input (change)="updateLocation()"
                   pInputText
                   id="climateControlledText"
                   placeholder="leave blank if just Climate Controlled"
                   class="full-width"
                   [(ngModel)]="locationData.climateControlledText" />
          </div>
          <div class="col-md-12">
            <md-slide-toggle (change)="updateShowAnnouncement($event)"
                             [(ngModel)]="locationData.showAnnouncement">
              <p>Show Announcement at the top of all pages for this location</p>
            </md-slide-toggle>
            <div *ngIf="locationData.showAnnouncement">
              <div class="mb-5 d-flex flex-column">
                <h5 class="mb-4">Announcement</h5>
                <textarea pInputTextarea
                          [froalaEditor]="options"
                          [(froalaModel)]="locationData.announcementText"
                          id="announcementText"
                          cols="30"
                          rows="4"></textarea>
                <button type="button"
                        class="btn btn-primary mt-4 ml-auto"
                        (click)="updateLocation()">Save</button>
              </div>
              <div>
                <label for="announcementBgColor">Announcement BG Color</label>
                <input (change)="updateLocation()"
                       pInputText
                       id="announcementBgColor"
                       class="full-width"
                       [(ngModel)]="locationData.announcementBgColor" />
              </div>
              <div>
                <label for="announcementColor">Announcement Color</label>
                <input (change)="updateLocation()"
                       pInputText
                       id="announcementColor"
                       class="full-width"
                       [(ngModel)]="locationData.announcementColor" />
              </div>
              <div class="mb-5">
                <label for="announcementFontSize">Announcement Font Size</label>
                <input (change)="updateLocation()"
                       pInputText
                       id="announcementFontSize"
                       class="full-width"
                       [(ngModel)]="locationData.announcementFontSize" />
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <md-slide-toggle (change)="updateShowCustomerPortalAnnouncement($event)"
                             [(ngModel)]="locationData.showCustomerPortalAnnouncement">
              <p>Show Announcement at the top of the customer portal for this location</p>
            </md-slide-toggle>
            <div *ngIf="locationData.showCustomerPortalAnnouncement">
              <div class="mb-5 d-flex flex-column">
                <h5 class="mb-4">Customer Portal Announcement</h5>
                <textarea pInputTextarea
                          [froalaEditor]="options"
                          [(froalaModel)]="locationData.customerPortalAnnouncementText"
                          id="customerPortalAnnouncementText"
                          cols="30"
                          rows="4"></textarea>
                <button type="button"
                        class="btn btn-primary mt-4 ml-auto"
                        (click)="updateLocation()">Save</button>
              </div>
              <div>
                <label for="customerPortalAnnouncementBgColor">Customer Portal Announcement BG Color</label>
                <input (change)="updateLocation()"
                       pInputText
                       id="customerPortalAnnouncementBgColor"
                       class="full-width"
                       [(ngModel)]="locationData.customerPortalAnnouncementBgColor" />
              </div>
              <div>
                <label for="customerPortalAnnouncementColor">Customer Portal Announcement Color</label>
                <input (change)="updateLocation()"
                       pInputText
                       id="customerPortalAnnouncementColor"
                       class="full-width"
                       [(ngModel)]="locationData.customerPortalAnnouncementColor" />
              </div>
              <div class="mb-5">
                <label for="customerPortalAnnouncementFontSize">Customer Portal Announcement Font Size</label>
                <input (change)="updateLocation()"
                       pInputText
                       id="customerPortalAnnouncementFontSize"
                       class="full-width"
                       [(ngModel)]="locationData.customerPortalAnnouncementFontSize" />
              </div>
            </div>
          </div>
          <div class="col-xs-12">
            <md-slide-toggle [(ngModel)]="locationData.usePtiCore"
                             (change)="updateUsePtiCore($event)">Use PTI Core?</md-slide-toggle>
          </div>
          <div *ngIf="locationData.usePtiCore"
               class="col-xs-12">
            <label for="ptiCoreDeviceId">PTI Core Device ID</label>
            <input (change)="updateLocation()"
                   pInputText
                   id="ptiCoreDeviceId"
                   class="full-width"
                   [(ngModel)]="locationData.ptiCoreDeviceId" />
          </div>
          <div class="col-xs-12">
            <md-slide-toggle [(ngModel)]="locationData.useNoke"
                             (change)="updateUseNoke($event)">Use Noke?</md-slide-toggle>
          </div>
          <div *ngIf="locationData.useNoke"
               class="col-xs-12">
            <label for="nokeId">Noke ID</label>
            <input (change)="updateLocation()"
                   pInputText
                   id="nokeId"
                   class="full-width"
                   [(ngModel)]="locationData.nokeId" />
          </div>
          <div class="col-xs-12">
            <p>Disable Bulletins</p>
            <p-multiSelect [styleClass]="'full-width'"
                           [filter]="false"
                           [options]="bulletinDropdownOptions"
                           [(ngModel)]="locationData.disabledBulletins"></p-multiSelect>
          </div>
          <div class="col-xs-12">
            <button type="button"
                    class="btn btn-primary"
                    color="primary"
                    (click)="copyBulletinSettings()">Copy bulletin settings to all locations</button>
          </div>
        </div>
        <div class="row row-margin">
          <div class="col-xs-12">
            <br>
            <br>
            <p><b>Location-Specific Filters</b></p>
            <br>
            <md-slide-toggle [(ngModel)]="locationData.unitFilters.useLocationUnitFilters">Use Location
              Filters for
              {{locationData.name}} </md-slide-toggle>
            <br>
            <md-slide-toggle *ngIf="locationData.unitFilters.useLocationUnitFilters"
                             [(ngModel)]="locationData.unitFilters.showFeaturesFilters">Show Feature
              Filters</md-slide-toggle>
            <hr *ngIf="locationData.unitFilters.useLocationUnitFilters && locationData.unitFilters.showFeaturesFilters">
            <md-slide-toggle *ngIf="locationData.unitFilters.useLocationUnitFilters && locationData.unitFilters.showFeaturesFilters"
                             [(ngModel)]="locationData.unitFilters.showClimate">Show Climate Controlled
              Filter</md-slide-toggle>
            <br *ngIf="locationData.unitFilters.useLocationUnitFilters && locationData.unitFilters.showFeaturesFilters">
            <md-slide-toggle *ngIf="locationData.unitFilters.useLocationUnitFilters && locationData.unitFilters.showFeaturesFilters"
                             [(ngModel)]="locationData.unitFilters.showInside">Show Inside Filter
            </md-slide-toggle>
            <br *ngIf="locationData.unitFilters.useLocationUnitFilters && locationData.unitFilters.showFeaturesFilters">
            <md-slide-toggle *ngIf="locationData.unitFilters.useLocationUnitFilters && locationData.unitFilters.showFeaturesFilters"
                             [(ngModel)]="locationData.unitFilters.showPowerOutlet">Show Power Outlet
              Filter</md-slide-toggle>
            <br *ngIf="locationData.unitFilters.useLocationUnitFilters && locationData.unitFilters.showFeaturesFilters">
            <md-slide-toggle *ngIf="locationData.unitFilters.useLocationUnitFilters && locationData.unitFilters.showFeaturesFilters"
                             [(ngModel)]="locationData.unitFilters.showUnitAlarm">Show Unit Alarm Filter
            </md-slide-toggle>
            <br *ngIf="locationData.unitFilters.useLocationUnitFilters && locationData.unitFilters.showFeaturesFilters">
            <md-slide-toggle *ngIf="locationData.unitFilters.useLocationUnitFilters && locationData.unitFilters.showFeaturesFilters"
                             [(ngModel)]="locationData.unitFilters.showGroundFloor">Show Ground Floor
              Filter</md-slide-toggle>
            <br>
            <button type="button"
                    class="btn btn-primary"
                    color="primary"
                    style="margin-top:15px;"
                    (click)="updateLocation()">Save Filters</button>
          </div>
        </div>
      </div>
    </div>

    <div class="row sm-padding-top">
      <div class="col-xs-12 col-sm-4">
        <h4>Social Media Links</h4>
        <md-slide-toggle (change)="updateShowSocialLinks($event)"
                         [(ngModel)]="locationData.showSocialLinks">
          <p> Show social links in footer</p>
        </md-slide-toggle>
        <p>
          <a target="_blank"
             href="https://app.hubspot.com/file-manager-beta/3852224/folder/Social%20Media%20Icons">
            Click here
          </a> for the icon options.
        </p>
        <div *ngFor="let link of locationData.socialLinks; let index = index">
          <img style="display:inline-block;width:5%"
               [src]="locationData.socialLinks[index].iconUrl">
          <input pInputText
                 style="display:inline-block;margin-top:15px;width:37.5%"
                 placeholder="url"
                 [(ngModel)]="locationData.socialLinks[index].url" />
          <input pInputText
                 style="display:inline-block;margin-top:15px;width:37.5%"
                 placeholder="icon url"
                 [(ngModel)]="locationData.socialLinks[index].iconUrl" />
          <button type="button"
                  class="btn btn-primary"
                  color="primary"
                  style="margin-top:15px;margin-left:5%;width:10%"
                  (click)="removeSocialLink(index)">Remove</button>
        </div>

        <button type="button"
                class="btn btn-secondary"
                color="accent"
                style="margin-top:15px;"
                (click)="locationData.socialLinks.push({url: null, iconUrl: null})">Add Link</button>
        <button type="button"
                class="btn btn-primary"
                color="primary"
                style="margin-top:15px;"
                (click)="updateLocation()">Save Links</button>
        <div *ngIf="locationData?.otherSocial"
             class="panel panel-info"
             style="margin-top: 20px;">
          <div class="panel-heading">
            <h3 class="panel-title">Other Social Media From Onboarding</h3>
          </div>
          <div class="panel-body">
            {{ locationData.otherSocial }}
          </div>
        </div>
      </div>
      <div class="col-sm-4">
        <h4>Payments</h4>
        <p>Number of Months Allowed for Prepay</p>
        <md-select [(ngModel)]="locationData.prepayMonths"
                   (change)="updateLocation()">
          <md-option *ngFor="let num of prepayOptions"
                     [value]="num.value">
            {{ num.title }}
          </md-option>
        </md-select>
        <br>
        <br>
        <md-slide-toggle (change)="updateShowPayments($event)"
                         [(ngModel)]="locationData.acceptPayments">Allow Payments through the portal?
        </md-slide-toggle>
        <br>
        <br>
        <p *ngIf="locationData?.acceptPayments == false">Toast Message</p>
        <input name="acceptPaymentsMessage"
               pInputText
               *ngIf="locationData?.acceptPayments == false"
               (change)="updateLocation()"
               [(ngModel)]="locationData.acceptPaymentsMessage"
               class="full-width"
               type="text">
      </div>
      <div class="col-sm-4">
        <h4>Rentals</h4>
        <md-slide-toggle (change)="updateHideUnits($event)"
                         [(ngModel)]="locationData.hideUnits">Completely hide units?</md-slide-toggle>
        <br>
        <br>
        <md-slide-toggle (change)="updateHideRentals($event)"
                         [(ngModel)]="locationData.hideRentals">Hide Rental buttons?</md-slide-toggle>
        <br>
        <br>
        <md-slide-toggle (change)="updateHideJoinWaitlist($event)"
                         [(ngModel)]="locationData.hideJoinWaitlist">Hide Join Waitlist buttons?</md-slide-toggle>
        <br>
        <br>
        <md-slide-toggle (change)="updateHideCallNow($event)"
                         [(ngModel)]="locationData.hideCallNow">Hide Call Now buttons?</md-slide-toggle>
        <br>
        <br>
        <md-slide-toggle (change)="updateDisableRentals($event)"
                         [(ngModel)]="locationData.disableRentals">Disable Rentals (with a pop up message)?
        </md-slide-toggle>
        <br>
        <br>
        <p *ngIf="locationData?.disableRentals == true">Toast Message</p>
        <input name="disableRentalsMessage"
               pInputText
               *ngIf="locationData?.disableRentals == true"
               (change)="updateLocation()"
               [(ngModel)]="locationData.disableRentalsMessage"
               class="full-width"
               type="text">
        <h4>Claim Account Type</h4>
        <md-select class="twilio-number"
                   [(ngModel)]="locationData.claimAccountType"
                   placeholder="Type"
                   (change)="updateLocation()">
          <md-option *ngFor="let num of claimAccountOptions"
                     [value]="num.value">
            {{ num.title }}
          </md-option>
        </md-select>
      </div>
    </div>

    <div class="row sm-padding-top">
      <div class="col-xs-12">
        <h2>Location Home Page Header</h2>

        <md-slide-toggle *ngIf="clientData?.pages?.locationHome?.headerType === 'simple' || clientData?.pages?.locationHome?.headerType === 'slider' || clientData?.pages?.locationHome?.headerType === 'insights'"
                         (change)="updateUseVideoInstead($event)"
                         [(ngModel)]="locationData.useVideoInstead">
          Use video instead
        </md-slide-toggle>
        <md-slide-toggle *ngIf="clientData?.pages?.locationHome?.headerType === 'simple-video' || clientData?.pages?.locationHome?.headerType === 'video' || clientData?.pages?.locationHome?.headerType === 'big-title'"
                         (change)="updateUseSlideshowInstead($event)"
                         [(ngModel)]="locationData.useSlideshowInstead">
          Use slideshow instead
        </md-slide-toggle>
      </div>
      <div class="col-sm-12">
        <div class="row sm-padding-top">
          <div class="col-xs-12">
            <md-slide-toggle id="showSliderArrows"
                             (change)="updateShowSliderArrows($event)"
                             [(ngModel)]="locationData.showSliderArrows"> Show Arrows</md-slide-toggle>

          </div>
          <br>
          <br>

          <div class="col-xs-12">
            <md-slide-toggle id="sliderAutoPlay"
                             (change)="updateSliderAutoPlay($event)"
                             [(ngModel)]="locationData.sliderAutoPlay"> Autoplay Slider</md-slide-toggle>
          </div>

        </div>
        <br>
        <button type="button"
                class="btn btn-primary"
                style="margin-top:15px;"
                (click)="copyFromHomeSlides('locationHomeSlides')">Copy from Home Page Slides</button>
        <button type="button"
                class="btn btn-primary"
                style="margin-top:15px;"
                (click)="copyFromLocationBoxSlides()">Copy from Location Box Slides</button>
        <br>
        <div class="col-md-6 my-5">
          <label>Slider Header URLs - leave none to default to facility slides</label>
          <app-slideshow (onSave)="updateLocation()"
                         [(slides)]="locationData.sliderUrls"
                         [showSliderArrows]="locationData.showSliderArrows"
                         [sliderAutoPlay]="locationData.sliderAutoPlay"></app-slideshow>
        </div>
      </div>
      <div *ngIf="!locationData?.useSlideshowInstead && (locationData?.useVideoInstead || clientData?.pages?.locationHome?.headerType === 'simple-video' || clientData?.pages?.locationHome?.headerType === 'video' || clientData?.pages?.locationHome?.headerType === 'big-title' || clientData?.pages?.locationHome?.headerType === 'simple' || clientData?.pages?.locationHome?.headerType === 'insights')"
           class="col-sm-6">
        <div class="row sm-padding-top">
          <div class="col-xs-12">
            <label>Video Header URL - leave blank to use facility video url</label>
            <input class="full-width"
                   type="text"
                   pInputText
                   [(ngModel)]="locationData.videoHeaderUrl" />
            <button (click)="updateLocation()"
                    class="saveButton"
                    class="btn btn-primary"
                    color="primary">Save</button>
          </div>
        </div>
      </div>
      <div *ngIf="clientData?.associations == 'original'"
           class="col-sm-6">
        <div class="row sm-padding-top">
          <div class="col-xs-12">
            <label>Location-Specific associations</label>
            <div class="col-xs-12 sm-margin-top">
              <label>Title</label>
              <input pInputText
                     class="full-width"
                     (change)="updateLocation()"
                     [(ngModel)]="locationData.associationTitle" />
            </div>
            <div class="col-xs-12 sm-margin-top">
              <label>Subtitle</label>
              <input pInputText
                     class="full-width"
                     (change)="updateLocation()"
                     [(ngModel)]="locationData.associationSubtitle" />
            </div>
            <div *ngFor="let link of locationData.associationLogos; let index = index">
              <input pInputText
                     style="display:inline-block;margin-top:15px;width:20%"
                     placeholder="url"
                     [(ngModel)]="locationData.associationLogos[index].url" />
              <input pInputText
                     style="display:inline-block;margin-top:15px;width:20%"
                     placeholder="icon url"
                     [(ngModel)]="locationData.associationLogos[index].iconUrl" />
              <input pInputText
                     style="display:inline-block;margin-top:15px;width:20%"
                     placeholder="Icon ALT Text"
                     [(ngModel)]="locationData.associationLogos[index].altText" />
              <input pInputText
                     style="display:inline-block;margin-top:15px;width:20%"
                     placeholder="Icon Title Text"
                     [(ngModel)]="locationData.associationLogos[index].titleText" />
              <button type="button"
                      class="btn btn-primary"
                      color="primary"
                      style="margin-top:15px;margin-left:5%;width:10%"
                      (click)="removeAssociationLink(index)">Remove</button>
            </div>

            <button type="button"
                    class="btn btn-secondary"
                    color="accent"
                    style="margin-top:15px;"
                    (click)="locationData.associationLogos.push({url: null, iconUrl: null})">Add
              Association
              Logo</button>
            <button type="button"
                    class="btn btn-primary"
                    color="primary"
                    style="margin-top:15px;"
                    (click)="updateLocation()">Save Association Logos</button>
          </div>
        </div>
      </div>
    </div>

    <md-card-header *ngIf="clientData?.reviewSettings?.isActive"
                    class="sm-padding-top">
      <md-card-title>
        <h2>Reviews Page Settings</h2>
      </md-card-title>
    </md-card-header>
    <div *ngIf="clientData?.reviewSettings?.isActive"
         class="row">
      <div class="col-xs-12 col-md-6 sm-margin-top">
        <label>Page Title (in header)</label>
        <input pInputText
               class="full-width"
               (change)="updateLocation()"
               [(ngModel)]="locationData?.reviewsPage.pageTitle" />
      </div>
      <!-- <div class="col-xs-12 col-md-6 sm-margin-top">
        <label>Leave a review link URL</label>
        <input pInputText
               class="full-width"
               (change)="updateLocation()"
               [(ngModel)]="locationData?.reviewsPage.reviewLinkUrl" />
      </div> -->
      <div class="col-xs-12 col-md-6 sm-margin-top">
        <label>Meta Title</label>
        <input pInputText
               class="full-width"
               (change)="updateLocation()"
               [(ngModel)]="locationData?.reviewsPage.metaTitle" />
      </div>
      <div class="col-xs-12 col-md-6 sm-margin-top">
        <p>
          <b>Location image is used by default. If you put one here it overides that.</b>
        </p>
        <label>Meta Image</label>
        <input pInputText
               class="full-width"
               (change)="updateLocation()"
               [(ngModel)]="locationData?.reviewsPage.metaImage" />
      </div>
      <div class="col-xs-12 col-md-6 sm-margin-top">
        <label>Meta Image Alt</label>
        <input pInputText
               class="full-width"
               (change)="updateLocation()"
               [(ngModel)]="locationData?.reviewsPage.metaImageAlt" />
      </div>
      <div class="col-xs-12 col-md-6 sm-margin-top">
        <label>Meta Description</label>
        <textarea pInputTextarea
                  (change)="updateLocation()"
                  class="full-width text-area-box"
                  [(ngModel)]="locationData?.reviewsPage.metaDescription"></textarea>
      </div>
      <div class="col-xs-12 col-md-6 sm-margin-top">
        <label>Review Page Blurb (HTML allowed)</label>
        <textarea pInputTextarea
                  class="full-width text-area-box"
                  [froalaEditor]="options"
                  [(froalaModel)]="locationData?.reviewsPage.reviewBlurb"></textarea>
        <button type="button"
                class="btn btn-primary"
                color="primary"
                style="margin-top:15px;"
                (click)="updateLocation()">Save</button>
      </div>
    </div>
    <md-card-header class="sm-padding-top">
      <md-card-title>
        <h2>Office Hour Settings</h2>
      </md-card-title>
    </md-card-header>
    <div class="row">
      <div class="col-md-6">
        <div class="col-xs-12">
          <label>Office Hours Text</label>
          <input pInputText
                 class="full-width"
                 (change)="updateLocation()"
                 [(ngModel)]="locationData.officeHoursText" />
        </div>
        <scs-office-hours [clientData]="clientData"
                          [officeHours]="officeHours"
                          [locationKey]="locKey"></scs-office-hours>

        <div *ngIf="locationData?.onboardingHours"
             class="panel panel-info"
             style="margin-top: 20px;">
          <div class="panel-heading">
            <h3 class="panel-title">Hours From Onboarding</h3>
          </div>
          <div class="panel-body"
               [innerHtml]="locationData.onboardingHours">
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="col-xs-12">
          <md-slide-toggle [(ngModel)]="locationData.noGate"
                           (change)="updateNoGate($event)">No gate!</md-slide-toggle>
        </div>
        <div class="col-xs-12">
          <label>Gate Hours Text</label>
          <input pInputText
                 class="full-width"
                 (change)="updateLocation()"
                 [(ngModel)]="locationData.gateHoursText" />
        </div>
        <scs-gate-hours *ngIf="locationData.noGate === false"
                        [clientData]="clientData"
                        [gateHours]="gateHours"
                        [locationKey]="locKey"></scs-gate-hours>
        <div *ngIf="locationData?.onboardingAccessHours"
             class="panel panel-info"
             style="margin-top: 20px;">
          <div class="panel-heading">
            <h3 class="panel-title">Access Hours From Onboarding</h3>
          </div>
          <div class="panel-body"
               [innerHtml]="locationData.onboardingAccessHours">
          </div>
        </div>
      </div>
    </div>

    <md-card-header>
      <md-card-title>
        <h2>Email Notification Settings</h2>
      </md-card-title>
    </md-card-header>
    <div class="row">
      <div class="col-md-6">
        <label>Email Color</label>
        <input pInputText
               class="my-5"
               (change)="updateLocation()"
               [(ngModel)]="locationData.emailHex" />
        <button type="button"
                class="btn btn-primary"
                color="primary"
                (click)="copyEmailColorSettings()">Copy email color to all locations</button>
      </div>
    </div>
    <div *ngIf="clientData">
      <div class="row">
        <div class="col-md-6">
          <label for="reservationBlurb">Custom Reservation Blurb</label>
          <textarea pInputTextarea
                    id="reservationBlurb"
                    class="full-width"
                    [froalaEditor]="options"
                    [(froalaModel)]="locationData.customBlurbReservation"></textarea>
          <button type="button"
                  class="btn btn-primary"
                  color="primary"
                  style="margin-top:15px;"
                  (click)="updateLocation()">Save</button>
          <scs-site-admin-emails [clientData]="clientData"
                                 [locationKey]="locKey"
                                 [emailDBName]="'reservationConfirmation'"
                                 [emailName]="'Reservation Confirmation'"></scs-site-admin-emails>
        </div>
        <div class="col-md-6">
          <scs-site-admin-emails [clientData]="clientData"
                                 [locationKey]="locKey"
                                 [emailDBName]="'contactFormSubmissions'"
                                 [emailName]="'Contact Form Submissions'"></scs-site-admin-emails>
          <scs-site-admin-emails [clientData]="clientData"
                                 [locationKey]="locKey"
                                 [emailDBName]="'bccEmailAddresses'"
                                 [emailName]="'BCC Email Addresses'"></scs-site-admin-emails>
        </div>
      </div>
      <div class="row"
           *ngIf="clientData?.propertySoftware != 'none'">
        <div class="col-md-6">
          <label for="reservationBlurb">Custom Rental Blurb</label>
          <textarea pInputTextarea
                    id="reservationBlurb"
                    class="full-width"
                    [froalaEditor]="options"
                    [(froalaModel)]="locationData.customBlurbRental"></textarea>
          <button type="button"
                  class="btn btn-primary"
                  color="primary"
                  style="margin-top:15px;"
                  (click)="updateLocation()">Save</button>
          <scs-site-admin-emails [clientData]="clientData"
                                 [locationKey]="locKey"
                                 [emailDBName]="'rentalConfirmation'"
                                 [emailName]="'Rental Confirmation'"></scs-site-admin-emails>
        </div>
        <div class="col-md-6">
          <scs-site-admin-emails [clientData]="clientData"
                                 [locationKey]="locKey"
                                 [emailDBName]="'moveOutDateConfirmation'"
                                 [emailName]="'Move Out Date Confirmation'"></scs-site-admin-emails>
        </div>
        <div class="col-md-6">
          <scs-site-admin-emails [clientData]="clientData"
                                 [locationKey]="locKey"
                                 [emailDBName]="'customerInfoUpdateNotification'"
                                 [emailName]="'Customer Info Update Notification'"></scs-site-admin-emails>
        </div>
      </div>
      <div class="row"
           *ngIf="clientData?.propertySoftware != 'none'">
        <div class="col-md-6">
          <scs-site-admin-emails [clientData]="clientData"
                                 [locationKey]="locKey"
                                 [emailDBName]="'newAccountCreation'"
                                 [emailName]="'New Web Account Confirmation'"></scs-site-admin-emails>
        </div>
        <div class="col-md-6">
          <scs-site-admin-emails [clientData]="clientData"
                                 [locationKey]="locKey"
                                 [emailDBName]="'passwordReset'"
                                 [emailName]="'Password Reset Confirmation'"></scs-site-admin-emails>
        </div>
      </div>
      <div class="row"
           *ngIf="clientData?.propertySoftware != 'none'">
        <div class="col-md-6">
          <scs-site-admin-emails [clientData]="clientData"
                                 [locationKey]="locKey"
                                 [emailDBName]="'paymentConfirmation'"
                                 [emailName]="'Online Payment Confirmation'"></scs-site-admin-emails>
        </div>
        <div class="col-md-6">
          <scs-site-admin-emails [clientData]="clientData"
                                 [locationKey]="locKey"
                                 [emailDBName]="'changeOfAutoPayConfirmation'"
                                 [emailName]="'Auto Pay Change Confirmation'"></scs-site-admin-emails>
        </div>
      </div>
      <div class="row"
           *ngIf="clientData?.propertySoftware != 'none'">
        <div class="col-md-6">
          <scs-site-admin-emails [clientData]="clientData"
                                 [locationKey]="locKey"
                                 [emailDBName]="'reportAProblem'"
                                 [emailName]="'Mobile App: Report a Problem'"></scs-site-admin-emails>
        </div>
        <!--<div class="col-md-6">-->
        <!--<scs-site-admin-emails [clientData]="clientData" [emailDBName]="'driversLicensePics'" [emailName]="'Mobile App: Driver\'s License Pictures'"></scs-site-admin-emails>-->
        <!--</div>-->
      </div>

      <div *ngIf="clientData.reviewSettings?.sendReviewsSms"
           class="row">
        <div class="col-xs-12 col-sm-6">
          <label>SMS Reviews Link URL</label>
          <input pInputText
                 class="full-width"
                 (change)="updateSmsReviewLinkUrl()"
                 [(ngModel)]="locationData.smsReviewLinkUrl" />
        </div>
      </div>
    </div>

  </md-card>
</div>

<div *ngIf="afService.isBilly"
     class="container my-5">
  <div class="row">
    <div class="col-xs-12 text-center">
      <img
           src="https://firebasestorage.googleapis.com/v0/b/storpug-main.appspot.com/o/IMG_1203.jpg?alt=media&token=60fb1f61-86b9-499d-87bd-da438ddd2919">
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/view-location/view-location.component.html